module.exports = __webpack_public_path__ + "img/choose-up-12_3 virtual.e4043a75.png";